import React, { useEffect, useRef , useState} from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick"; // Importing the Slider component from react-slick
import styles from "./CharityCarousel.module.scss";
import Srcset from "@/common/Srcset";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

export default function CharityCarousel() {
  const causeList = useSelector((state) => state.general.cause_list);
  const sliderRef = useRef(null);

  let stateInitial = {
    activeSlide: 1,
  };
  const [state, setState] = useState(stateInitial);

  const isTablet = useMediaQuery("(max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 767px)");

  const settings = {
    dots: false,
    infinite: true, 
    speed: 500,
    slidesToShow: 9, 
    slidesToScroll: 9,
    autoplay: false,
    arrows: false,
    draggable: false,
    afterChange: (activeSlide) => setState({ activeSlide: Math.ceil(activeSlide / 9) + 1}),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 7,
          centerMode:true,
          centerPadding:"2%",
          afterChange: (activeSlide) =>
            setState({ activeSlide: Math.ceil(activeSlide / 7.5) + 1}),
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: true,
          centerPadding:'10%',
          afterChange: (activeSlide) =>
            setState({ activeSlide: Math.ceil(activeSlide/2.5)  + 1 }),
        },
      },
    ],
  };

  const causeListLength = causeList? causeList.filter(cause => cause?.charity_logo).length: 0;
  let slideCount = Math.ceil(causeList && causeListLength / 9) ;
  if(isMobile) {
    slideCount = Math.ceil(causeList && causeListLength / 2.5);
  }
  else if(isTablet) { 
    slideCount = Math.ceil(causeList && causeListLength / 7.5);
  }

  if (!causeList || causeList.length === 0) {
    return <div>No charities available.</div>;
  }

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.header}>
        <div className={`${styles.headerText}  xxx-large-md xx-large-sm x-large-xs`}>Fashion a better future</div>
        <div className={`${styles.caption} large-md x-small-sm x-small-xs`}>
        20% of the net proceeds from every purchase at Olivela supports our
        cause partners—at zero extra cost to you.
      </div>
        <div className={styles.navigationButtons}>
          <button
            className={styles.prev}
            onClick={handlePrev}
            aria-label="Previous"
            tabIndex={0}
          >
          <Srcset
            src="images/Icons/Chevron/large.svg"
            alt="Prev navigation"
            width="12"
            height="12"
          />
          </button>
          {slideCount > 1 && (
          <div className="small-md small-sm small-xs italic slider-counter">
            <span className="active-slide">{state.activeSlide}</span>
            <span className="slash">/</span>
            <span className="total-slide">{slideCount}</span>
          </div>
        )}
          <button
            className={styles.next}
            onClick={handleNext}
            aria-label="Next"
            tabIndex={0}
          >
            <Srcset
            src="images/Icons/Chevron/large.svg"
            alt="Next navigation"
            width="12"
            height="12"
          />
          </button>
        </div>

      </div>

      <div className={styles.carousel}>
        <Slider ref={sliderRef} {...settings}>
          {/*  display the charity logos only if the charity is set to active  */}
          {causeList?.map((cause, index) => (
           cause?.charity_logo && cause?.active == 1 && ( <div key={index} className={`${styles.charityItem}`}>  
              <a key={index} {...cause?.benefit_url?{href:"/charity/"+cause?.benefit_url}:{}} tabIndex={0}>
              <Srcset
                height="100"
                width="100"
                src={cause?.charity_logo}
                alt={cause?.name ? cause.name : "logo"}
                className={`${styles.charityLogo}`}
              />
              </a>
            </div> )
          ))}
        </Slider>
      </div>
        <button className={styles.learnMoreButton}>
          <a href="/impact" tabIndex={0}>Learn More</a>
        </button>
    </div>
  );
}